"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeChangeController = void 0;
// data-theme는 body 하나에만 붙으므로 관찰자도 하나면 된다.
// 토큰 카드가 수십 개씩 붙는 문서 페이지에서 인스턴스마다 관찰자를 만들지 않도록 모듈이 소유한다.
const hosts = new Set();
let observer;
function watchTheme() {
    if (observer)
        return;
    observer = new MutationObserver(() => hosts.forEach(host => host.requestUpdate()));
    observer.observe(document.body, { attributeFilter: ['data-theme'] });
}
/**
 * 테마가 바뀌면 호스트를 다시 렌더한다.
 * 계산된 스타일에서 값을 읽어 보여주는 요소는 CSS 변수가 교체된 것을 Lit이 알 수 없어
 * 갱신 시점을 스스로 만들어야 한다.
 */
class ThemeChangeController {
    constructor(host) {
        this.host = host;
        host.addController(this);
    }
    hostConnected() {
        watchTheme();
        hosts.add(this.host);
    }
    hostDisconnected() {
        hosts.delete(this.host);
    }
}
exports.ThemeChangeController = ThemeChangeController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUtY2hhbmdlLWNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aGVtZS1jaGFuZ2UtY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSwwQ0FBMEM7QUFDMUMseURBQXlEO0FBQ3pELE1BQU0sS0FBSyxHQUFHLElBQUksR0FBRyxFQUEwQixDQUFBO0FBQy9DLElBQUksUUFBc0MsQ0FBQTtBQUUxQyxTQUFTLFVBQVU7SUFDakIsSUFBSSxRQUFRO1FBQUUsT0FBTTtJQUVwQixRQUFRLEdBQUcsSUFBSSxnQkFBZ0IsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLGFBQWEsRUFBRSxDQUFDLENBQUMsQ0FBQTtJQUNsRixRQUFRLENBQUMsT0FBTyxDQUFDLFFBQVEsQ0FBQyxJQUFJLEVBQUUsRUFBRSxlQUFlLEVBQUUsQ0FBQyxZQUFZLENBQUMsRUFBRSxDQUFDLENBQUE7QUFDdEUsQ0FBQztBQUVEOzs7O0dBSUc7QUFDSCxNQUFhLHFCQUFxQjtJQUNoQyxZQUFvQixJQUE0QjtRQUE1QixTQUFJLEdBQUosSUFBSSxDQUF3QjtRQUM5QyxJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFFRCxhQUFhO1FBQ1gsVUFBVSxFQUFFLENBQUE7UUFDWixLQUFLLENBQUMsR0FBRyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUN0QixDQUFDO0lBRUQsZ0JBQWdCO1FBQ2QsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDekIsQ0FBQztDQUNGO0FBYkQsc0RBYUMifQ==